import {
  HEADER_SEARCH_BOX_CLICK,
  HEADER_SEARCH_BUTTON_CLICK,
  HEADER_SEARCH_ICON_CLICK,
  SWITCH_SEARCH_PLACEHOLDER_TEXT,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'
import { bindTrackingEvents } from 'shared/experiments/utils/tracking'

export default () => {
  const { isEnabled } = getExperimentOnClient(SWITCH_SEARCH_PLACEHOLDER_TEXT)

  if (!isEnabled) return

  void activateExperiment(SWITCH_SEARCH_PLACEHOLDER_TEXT)

  bindTrackingEvents([
    {
      selector: '.o-HeaderLarge #h-SearchBox [name="query-button"]',
      event: 'click',
      trackingEvent: HEADER_SEARCH_BUTTON_CLICK,
    },
    {
      selector: '.o-HeaderLarge #h-SearchBox #h-SearchBox__input',
      event: 'click',
      trackingEvent: HEADER_SEARCH_BOX_CLICK,
    },
    {
      selector: '.o-HeaderSmall .o-HeaderSmall__dummyInput',
      event: 'click',
      trackingEvent: HEADER_SEARCH_BOX_CLICK,
    },
    {
      selector: '.o-HeaderSmall [name="searchbox-mobile-search-icon"]',
      event: 'click',
      trackingEvent: HEADER_SEARCH_ICON_CLICK,
    },
  ])
}
